import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

import commonState from './common/state'
import commonMutations from './common/mutations'
import commonGetters from './common/getters'
import commonActions from './common/actions'

import behaviorState from './behavior/state'
import behaviorMutations from './behavior/mutations'

import regulatorState from './regulator/state'
import regulatorMutations from './regulator/mutations'
import regulatorActions from './regulator/actions'

import cpsState from './cps/state'
import cpsMutations from './cps/mutations'
import cpsActions from './cps/actions'
import getParams from '@/util/getParams'

import paymentState from './payment/state'
import paymentMutations from './payment/mutations'
import paymentActions from './payment/actions'

import domainState from './domain/state'
import domainMutations from './domain/mutations'
import domainActions from './domain/actions'

import registerModule from './register/registerModule'

import telegramState from './telegram/state'
import telegramMutations from './telegram/mutations'
import telegramGetters from './telegram/getters'

Vue.use(Vuex)

const common = {
  namespaced: true,
  state: commonState,
  mutations: commonMutations,
  getters: commonGetters,
  actions: commonActions,
}

const behavior = {
  namespaced: true,
  state: behaviorState,
  mutations: behaviorMutations,
}

const regulator = {
  namespaced: true,
  state: regulatorState,
  mutations: regulatorMutations,
  actions: regulatorActions,
}

const cps = {
  namespaced: true,
  state: cpsState,
  mutations: cpsMutations,
  actions: cpsActions,
}

const payment = {
  namespaced: true,
  state: paymentState,
  mutations: paymentMutations,
  actions: paymentActions,
}

const domain = {
  namespaced: true,
  state: domainState,
  mutations: domainMutations,
  actions: domainActions,
}

const telegram = {
  namespaced: true,
  state: telegramState,
  mutations: telegramMutations,
  getters: telegramGetters,
}

const device = getParams('device')
const plugins = device
  ? []
  : [
      createPersistedState({
        paths: ['common', 'behavior', 'regulator', 'cps', 'register', 'telegram', 'domain'],
      }),
    ]

export default new Vuex.Store({
  modules: {
    common,
    behavior,
    regulator,
    cps,
    payment,
    domain,
    register: registerModule,
    telegram,
  },
  plugins,
})
